import IconRocket1 from "./icon-rocket-1";
export default IconRocket1;